import apiClient from '../apiClient';

export const getUserActivity = async (userId, startDate, endDate, page = 1, pageSize = 50) => {
  const params = new URLSearchParams({ page, pageSize });
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  
  const response = await apiClient.get(`/audit/user/${userId}?${params}`);
  return response.data;
};

export const getUserActivityByName = async (userName, startDate, endDate, page = 1, pageSize = 50) => {
  const params = new URLSearchParams({ page, pageSize });
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  
  const response = await apiClient.get(`/audit/user-name/${encodeURIComponent(userName)}?${params}`);
  return response.data;
};

export const getResourceActivity = async (resourceId, resourceType, startDate, endDate, page = 1, pageSize = 50) => {
  const params = new URLSearchParams({ resourceType, page, pageSize });
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  
  const response = await apiClient.get(`/audit/resource/${resourceId}?${params}`);
  return response.data;
};
